import { faAngleRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './styles.scss';

type PortfolioSidebarSettingsOption = {
  label: string;
  handleClick: () => void;
  isActive: boolean;
};

export const PortfolioSidebarSettingsOption = ({
  label,
  handleClick,
  isActive = false,
}: PortfolioSidebarSettingsOption) => {
  return (
    <div className="portfolio-sidebar-settings-content-option">
      <button
        onClick={handleClick}
        className={`portfolio-sidebar-settings-content-option-button ${isActive ? 'portfolio-sidebar-settings-content-option-button-active' : ''}`}
      >
        {label}
        <FontAwesomeIcon icon={faAngleRight} />
      </button>
    </div>
  );
};
